import Container from "@/components/Container";
import Eyebrow from "@/components/Eyebrow";
import Reveal from "@/components/Reveal";
import Section from "@/components/Section";

const BLOCKS = [
  {
    number: "01",
    title: "We start with your operations, not with the technology.",
    body: "Before we recommend a single tool, we map how your business actually runs — where time goes, where errors happen, where margin leaks. An AI recommendation that doesn't trace back to a specific process is a guess.",
  },
  {
    number: "02",
    title: "We rank by payback, not by novelty.",
    body: "Every opportunity we find comes with an estimate of impact, effort, and time to value. You start with the one that pays for the rest, instead of the one that demos well.",
  },
  {
    number: "03",
    title: "We build it, not just brief it.",
    body: "You get working systems in production, integrated with the tools you already run — not a roadmap you have to hire someone else to execute.",
  },
  {
    number: "04",
    title: "We stay through the part where it gets used.",
    body: "The most common failure in AI adoption isn't the technology. It's a team that quietly goes back to the old way in week three. Training and change management are part of the engagement, not an upsell.",
  },
] as const;

export function WhyDifferent() {
  return (
    <Section tone="raised">
      <Container>
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[45fr_55fr] lg:gap-16">
          <div className="lg:sticky lg:top-[104px] lg:self-start">
            <Reveal>
              <Eyebrow>Why LAA</Eyebrow>
              <h2 className="mt-3 font-display text-h2 text-ink-900">
                Most AI consulting sells you a strategy deck or a pilot. Neither one changes your
                P&amp;L.
              </h2>
              <p className="mt-4 text-body-lg text-ink-500">We built LAA to do the other thing.</p>
            </Reveal>
          </div>

          <div className="rounded-2xl border border-ink-200 bg-paper-0 p-7 sm:p-10">
            {BLOCKS.map((block, i) => (
              <Reveal
                key={block.number}
                delay={i * 60}
                className={i === 0 ? "pb-8" : "border-t border-ink-200 pt-8 pb-8 last:pb-0"}
              >
                <span className="font-mono text-eyebrow uppercase font-medium text-brand-700">
                  {block.number}
                </span>
                <h3 className="mt-3 font-display text-h3 text-ink-900">{block.title}</h3>
                <p className="mt-3 measure text-body text-ink-600">{block.body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </Container>
    </Section>
  );
}

export default WhyDifferent;
